var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._b({tag:"component",attrs:{"to":_vm.path,"href":_vm.path,"path":_vm.path},nativeOn:{"click":function($event){return _vm.$emit('click')}}},'component',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }